import styled from 'styled-components'
import CreationToolSuperCutField from '../../../../../../types/super-cut-field'
import CaptionStyleField from '../../../../../form-fields/super-cut/caption-style'

const CaptionStyle = styled(CaptionStyleField)`
    grid-column: span 2;
`

type Props = {
    field: CreationToolSuperCutField
}

const CreationCaptureInfoCaptionStyleField = ({ field }: Props) => {
    return (
        <CaptionStyle
            {...{
                field,
            }}
        />
    )
}

export default CreationCaptureInfoCaptionStyleField
